export default "__VITE_ASSET__AwICKGp3__"